<template>
  <div class="flatNav">
    <div class="bg_left"></div>
    <div class="w">
      <div class="about" v-if="data.meta&&data.meta.des">
        <div class="title">{{data.meta.title}}</div>
        <div class="des">{{data.meta.des}}</div>
      </div>
      <div class="list" :class="data.children&&data.children.length>4?'warp':''">
        <div class="item" v-for="(item,index) in data.children" :key="index">
          <div>
            <div class="icon"><img :src="require('../../assets/images/' + item.meta.icon + '.png')" alt=""></div>
            <div class="title">
              <span v-if="!item.open" @click="menusClick(item)" style="cursor: pointer">{{item.meta.title}}</span>
              <!--         <router-link v-if="!item.open" :to="item.path">{{item.meta.title}}</router-link>-->
              <a v-else target="_blank" :href="item.open">{{item.meta.title}}</a>
            </div>
            <div class="des" v-if="item.meta&&item.meta.des">{{item.meta.des}}</div>
          </div>
          <!--      <div class="con">-->
          <!--        <div class="children" v-for="el in item.children">-->
          <!--          <p>{{el.meta.title}}</p>-->
          <!--          <p>{{el.meta.des}}</p>-->
          <!--        </div>-->
          <!--      </div>-->
        </div>
      </div>
    </div>
    <div></div>

    <!--    <el-dialog-->
    <!--      title=""-->
    <!--      v-if="dialogVisible"-->
    <!--      :visible.sync="dialogVisible"-->
    <!--      width="90%"-->
    <!--      append-to-body-->
    <!--      :fullscreen="true">-->
    <!--      <div style="margin-top: -30px">-->
    <!--        <el-tabs v-model="activeName" @tab-click="handleClick">-->
    <!--          <el-tab-pane label="信息大厅" name="1"><img :src="require('@/assets/images/logistics/shui1.png')" style="width: 100%"></el-tab-pane>-->
    <!--          <el-tab-pane label="订舱服务" name="2"><img :src="require('@/assets/images/logistics/shui2.png')" style="width: 100%"></el-tab-pane>-->
    <!--          <el-tab-pane label="在线下单" name="3"><img :src="require('@/assets/images/logistics/shui3.png')" style="width: 100%"></el-tab-pane>-->
    <!--          <el-tab-pane label="物流跟踪" name="4"><img :src="require('@/assets/images/logistics/shui4.png')" style="width: 100%"></el-tab-pane>-->
    <!--        </el-tabs>-->
    <!--      </div>-->
    <!--    </el-dialog>-->

    <!--    <el-dialog-->
    <!--      title=""-->
    <!--      v-if="dialogVisible2"-->
    <!--      :visible.sync="dialogVisible2"-->
    <!--      width="90%"-->
    <!--      append-to-body-->
    <!--      :fullscreen="true">-->
    <!--      <div style="margin-top: -30px">-->
    <!--        <el-tabs v-model="activeName2" @tab-click="handleClick">-->
    <!--          <el-tab-pane label="信息大厅" name="1"><img :src="require('@/assets/images/logistics/gong1.png')" style="width: 100%"></el-tab-pane>-->
    <!--          <el-tab-pane label="在线下单" name="2"><img :src="require('@/assets/images/logistics/gong2.png')" style="width: 100%"></el-tab-pane>-->
    <!--          <el-tab-pane label="物流跟踪" name="3"><img :src="require('@/assets/images/logistics/gong3.png')" style="width: 100%"></el-tab-pane>-->
    <!--        </el-tabs>-->
    <!--      </div>-->
    <!--    </el-dialog>-->


  </div>
</template>

<script>
    export default {
        name: 'FlatNav',
        props: {
            data: {
                type: Object,
                default() {
                    return {}
                }
            },
            hid: {
                type: Boolean,
                default() {
                    return false
                }
            }
        },
        computed: {},
        data() {
            return {
                dialogVisible: false,
                dialogVisible2: false,
                activeName: '1',
                activeName2: '1'
            }
        },
        methods: {
            menusClick(item) {
                // if(item.path === '/waterage') {
                //   this.dialogVisible=true
                // } else if(item.path === '/roadFreight') {
                //   this.dialogVisible2=true
                // }
                if (item.target) {
                    let blank = this.$router.resolve(item.path)
                    window.open(blank.href, '_blank')
                }
            },
            handleClick(e) {

            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .flatNav {
    height: 230px;
    position: absolute;
    border-top: 1px #eee solid;
    background-color: #fff;
    padding: 0px;
    left: 0;
    display: flex;
    justify-content: left;
    align-items: center;
    right: 0;
    box-shadow: 0px 10px 14px 0px rgba(155, 172, 206, 0.6);
  }

  .bg_left {
    width: calc(50% - 600px);
    height: 100%;
    background: linear-gradient(270deg, #F2F5FA 0%, rgba(242, 245, 250, 0.9757) 63%, rgba(242, 245, 250, 0) 100%);
  }

  .flatNav .w {
    height: 100%;
    display: flex;
    align-items: center;
    margin: 0;
  }

  .list {
    height: 100%;
    display: flex;
    align-items: center;
  }

  .warp {
    flex-wrap: wrap;
  }

  .flatNav .warp .item .des {
    display: none;
  }

  .flatNav .warp .item {
    border-right: 0;
  }

  .flatNav .about {
    height: 100%;
    box-sizing: border-box;
    padding: 10px 95px 30px 0;
    background: url("../../assets/images/industryCenter/homeMenu_bg.png");
    background-size: 100% 100%;
  }

  .flatNav .about .des {
    width: 253px;
    font-size: 14px;
    font-weight: 400;
    color: #767676;
    line-height: 30px;
    margin-top: 20px;
  }

  .flatNav .about .title {
    font-size: 18px;
    /* font-family: Source Han Sans CN-Medium, Source Han Sans CN; */
    font-weight: 500;
    color: #1A1A1A;
    line-height: 28px;
  }

  .flatNav .warp .item > div {
    display: flex;
    align-items: center;
  }

  .flatNav .warp .item .icon {
    margin-right: 20px;
  }

  .flatNav .item {
    width: 220px;
    height: 100%;
    text-align: center;
    border-right: 1px #DDDDDD solid;
    padding-right: 40px;
    position: relative;
    /*padding-left: 30px;*/
    overflow: hidden;
  }

  .flatNav .item {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    flex-wrap: wrap;
    box-sizing: border-box;
    padding: 0 30px;
  }

  .flatNav .item:last-child {
    border-right: 0px;
  }

  .flatNav .item:hover {
    background-color: RGBA(242, 245, 250, 1);
  }

  .flatNav .about {
    background-color: RGBA(242, 245, 250, 1);
    text-align: left;
    padding-right: 50px;
  }

  .flatNav .about .title {
    font-weight: 600 !important;
  }

  .flatNav .item .title, .flatNav .item .title a, .flatNav .about .title {
    color: #1A1A1A;
    font-weight: 500;
    font-size: 16px;
    margin-bottom: 15px;
    margin-top: 10px;
    position: relative;
    z-index: 2;

  }

  .flatNav .item .icon {
    margin-top: 10px;
  }

  .flatNav .about .title {
    margin-top: 30px;
  }

  .flatNav .item .title:hover a {
    color: #0256FF;
  }

  .flatNav .item .des, .flatNav .about .des {
    color: #767676;
    font-size: 14px;
    line-height: 26px;
    position: relative;
    z-index: 2;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .flatNav .about .des {
    -webkit-line-clamp: 4;
  }

  .flatNav .about img {
    position: absolute;
    right: 0;
    bottom: 0;
    z-index: 1;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/styleMenus.vue